module.exports = __webpack_public_path__ + "img/personalCardTypes.2732cbe2.svg";